import { store } from "../../store/store";
import wsClient from "./wsClient";
import { buildAuthMessage } from "../utils/buildAuthMessage";

// Повторная привязка WS-сокета к сессии (DAI-1183).
// Бэкенд связывает сокет с сессией только при auth-сообщении и session.switch.
// После обновления страницы redux пуст → auth уходит без session_id, сокет
// остаётся непривязанным, и адресные пуши (campaign_form.update, прогресс
// задач) публикуются в Redis и молча теряются. Поэтому при каждой смене
// sessionId на не-null (и открытом сокете) повторно отправляем auth:
// обработчик auth на бэкенде идемпотентно перерегистрирует сокет
// (ws_manager.register) и восстанавливает статус задач — без перезагрузки
// истории, как это делает session.switch.
let registered = false;
let lastSessionId: string | null = null;

export const registerWsSessionRebind = () => {
	// Подписка регистрируется один раз за жизнь приложения
	if (registered) return;
	registered = true;
	lastSessionId = store.getState().session.sessionId;

	store.subscribe(() => {
		const sessionId = store.getState().session.sessionId;

		// null — сессия закрыта/сброшена: re-auth не нужен
		if (sessionId === null) return;
		// store.subscribe срабатывает на любое действие — реагируем
		// только на реальную смену значения (prev !== current)
		if (sessionId === lastSessionId) return;
		lastSessionId = sessionId;

		// Сокет закрыт — молча пропускаем: при следующем onopen обычный
		// auth уже уйдёт с актуальным session_id
		if (!wsClient.isOpen()) return;

		wsClient.sendMessage(buildAuthMessage());
	});
};
